import { AmbientVideo } from "./AmbientVideo";

// Ambient full-bleed section backdrop — same monochrome treatment as the
// hero video (desaturated, dimmed, faded into the canvas at both edges).
// Sources are seamless-loop re-encodes (last second crossfaded into the
// first at constant 24fps, faststart) so the loop point is invisible.
// Decorative only: hidden for reduced-motion users, invisible to a11y tree.
// Render as the first child of a `relative` section and wrap the section's
// content in `relative z-[1]` so it sits above.
export function BackdropVideo({ src, className }: { src: string; className?: string }) {
  return (
    <>
      <AmbientVideo src={src} className={className} />
      <div
        aria-hidden
        className="absolute inset-x-0 top-0 z-0 h-24 bg-gradient-to-b from-background to-transparent"
      />
      <div
        aria-hidden
        className="absolute inset-x-0 bottom-0 z-0 h-24 bg-gradient-to-t from-background to-transparent"
      />
    </>
  );
}
